import { configureStore } from "@reduxjs/toolkit";
import {configure} from "@testing-library/react";

export const store = configureStore({
  reducer: {

  },
})